import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';

var SquareImage = function SquareImage() {
  return import(
  /* webpackChunkName: "square-image" */
  '~/components/atoms/Product/SquareImage.vue');
};

var ThumbnailListArrowButton = function ThumbnailListArrowButton() {
  return import(
  /* webpackChunkName: "thumbnail-list" */
  '~/components/molecules/Product/ThumbnailListArrowButton.vue');
};

export default {
  name: 'ThumbnailList',
  components: {
    SquareImage: SquareImage,
    ThumbnailListArrowButton: ThumbnailListArrowButton
  },
  props: {
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    isSlider: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentIndex: this.index
    };
  },
  computed: {
    maxIndex: function maxIndex() {
      return this.images.length - 1;
    }
  },
  watch: {
    index: function index(newValue) {
      if (newValue !== this.currentIndex) {
        this.currentIndex = newValue;
        this.scroll();
      }
    },
    images: function images() {
      this.updateIndex(0);
    }
  },
  mounted: function mounted() {
    if (this.index > 0) {
      this.scroll(false);
    }
  },
  methods: _objectSpread({}, mapMutations({
    setCurrentImage: 'product/SET_CURRENT_IMAGE',
    resetCurrentImage: 'product/RESET_CURRENT_IMAGE'
  }), {
    updateIndex: function updateIndex(index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
        this.$emit('update:index', this.currentIndex);
      }
    },
    selectIndexAndScroll: function selectIndexAndScroll(index) {
      this.updateIndex(index);
      this.scroll();
    },
    incrementIndex: function incrementIndex() {
      if (this.currentIndex + 1 < this.images.length) {
        this.currentIndex = this.currentIndex + 1;
        this.$emit('update:index', this.currentIndex);
        this.scroll();
      }
    },
    decrementIndex: function decrementIndex() {
      if (this.currentIndex - 1 >= 0) {
        this.currentIndex = this.currentIndex - 1;
        this.$emit('update:index', this.currentIndex);
        this.scroll();
      }
    },
    scroll: function scroll() {
      var smooth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var scrollSize = this.$refs.thumbnail[0].offsetHeight * this.currentIndex;
      this.$refs.slider.scrollTo({
        top: scrollSize,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.$refs.wrapper.scrollTo({
        top: scrollSize,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  })
};